import { render, staticRenderFns } from "./DeliveryNoteTable.vue?vue&type=template&id=d8b2e7ba&scoped=true&"
import script from "./DeliveryNoteTable.vue?vue&type=script&lang=js&"
export * from "./DeliveryNoteTable.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryNoteTable.vue?vue&type=style&index=0&id=d8b2e7ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b2e7ba",
  null
  
)

export default component.exports